module.exports = __webpack_public_path__ + "img/paypal.3b21772.svg";